import axios from 'axios';

// 动态获取 API 地址
// 如果是 HTTPS 访问（端口 3443），API 也用 HTTPS
// 如果是 HTTP 访问（端口 3000），API 用 HTTP
const getBaseURL = () => {
  const { protocol, hostname, port } = window.location;

  // 生产环境：HTTPS 访问或非开发端口，API 走相对路径（由 Nginx/Caddy 代理）
  if (protocol === 'https:' || (port !== '3000' && port !== '3001')) {
    return `/api`;
  }

  // 开发环境：HTTP 端口 3000/3001，API 用后端端口
  return `http://${hostname}:3000/api`;
};

// 创建axios实例
const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 401) {
        // token过期或未登录
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 403) {
        // 无权限
        console.error('无权限访问');
      } else if (status === 404) {
        console.error('接口不存在');
      } else {
        console.error('服务器错误:', data.message);
      }
      
      return Promise.reject(data);
    }
    
    return Promise.reject(error);
  }
);

export default request;
